import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import { StyledIcon } from '../../RoundIcon/styles';
import { StyledTag } from '../../Tag/styles';

export const StyledResourcesPreviewBlock = styled.article`  
  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin: 6rem 11rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    margin: 6rem 5rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
  }
`;

export const StyledCards = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};

  p {
    font-size: ${themeGet('scale.scaleBase')};
    margin: 0;
  }

  ul {
    margin-top: ${themeGet('scale.scaleUp03')};
    margin-left: 35px;
  }

  li {
    ${themeGet('font.whitneyMedium')}
    display: grid;
    grid-template-columns: ${themeGet('scale.scaleUp01')} auto;
    grid-column-gap: ${themeGet('scale.scaleDown03')};
    font-size: ${themeGet('scale.scaleDown01')};
    color: ${themeGet('color.colorGrayBlue80')};
  }

  li + li {
    margin-top: ${themeGet('scale.scaleUp03')};
  }

  svg {
    width: 100%;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    p {
      font-size: ${themeGet('scale.scaleBase')};
    }

    li {
      font-size: ${themeGet('scale.scaleDown01')};
      grid-template-columns: ${themeGet('scale.scaleUp03')} auto;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${themeGet('scale.scaleUp05')};
    grid-row-gap: ${themeGet('scale.scaleUp07')};

    margin-bottom: ${(props) => (props.hascta ? 0 : 'auto')};

    p {
      font-size: ${themeGet('scale.scaleUp02')};
    }

    li {
      font-size: ${themeGet('scale.scaleBase')};
    }
  }
`;

export const StyledCard = styled.div`
  .styled-card__inner {
    box-shadow: 0 0 1px 0 #a8b9d5, 0 12px 24px -6px #ebf2ff;
    background: ${themeGet('color.colorWhite')};
    border-radius: 3px;
    padding: 40px 32px;

    a {
      margin-left: 35px;
      margin-top: 24px;
    }

    .styled-card__title-row {
      display: flex;
      align-items: center;

      img {
        height: 40px;
        margin-right: 15px;
      }

      h2 {
        color: #2C4A7D;
        font-weight: 700;
        font-size: 21px;
        margin-bottom: 0;
      }
    }

    .resource-card__image-container{
      height: 30%;
      overflow: hidden;

      .gatsby-image-wrapper{
        height:100%;
      }
    }

    .resource-dot {
      height: 25px;
      width: 25px;
      background-color: green;
      border-radius: 50%;
      display: inline-block;
    }

    ul {
      li {
        font-weight: 400;
      }
    }
  }
`;

export const StyledList = styled.ul`
  h3 {
    font-size: ${themeGet('scale.scaleUp02')};
    color: ${themeGet('color.colorGrayBlue70')};
    margin-bottom: ${themeGet('scale.scaleBase')};
    padding-top: ${themeGet('scale.scaleDown04')};
  }

  p {
    margin: 0;
  }

  li {
    display: grid;
    align-items: start;
    grid-template-columns: ${themeGet('scale.scaleUp07')} auto;
    grid-column-gap: ${themeGet('scale.scaleDown01')};
  }

  li + li {
    margin-top: ${themeGet('scale.scaleUp03')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    li {
      grid-template-columns: ${themeGet('scale.scaleUp11')} auto;
      grid-column-gap: ${themeGet('scale.scaleUp03')};
    }

    li + li {
      margin-top: ${themeGet('scale.scaleUp05')};
    }

    h3 {
      padding-top: ${themeGet('scale.scaleUp02')};
    }
  }
`;

export const StyledContent = styled.div`
  p {
    font-size: ${themeGet('scale.scaleBase')};
    margin: 0;
  }

  ul {
    padding-top: ${themeGet('scale.scaleUp03')};
    margin-top: ${themeGet('scale.scaleUp03')};
    font-weight: 400;
  }

  li {
    ${themeGet('font.whitneyMedium')}
    display: grid;
    grid-template-columns: ${themeGet('scale.scaleUp01')} auto;
    grid-column-gap: ${themeGet('scale.scaleDown03')};
    font-size: ${themeGet('scale.scaleDown01')};
    color: ${themeGet('color.colorGrayBlue80')};
  }

  li + li {
    margin-top: ${themeGet('scale.scaleUp03')};
  }

  svg {
    width: 100%;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    p {
      font-size: ${themeGet('scale.scaleBase')};
    }

    li {
      font-size: ${themeGet('scale.scaleDown01')};
      grid-template-columns: ${themeGet('scale.scaleUp03')} auto;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: ${(props) => (props.hascta ? 0 : 'auto')};

    p {
      font-size: ${themeGet('scale.scaleUp02')};
    }

    li {
      font-size: ${themeGet('scale.scaleBase')};
    }
  }
`;